module.exports = __webpack_public_path__ + "img/card.9129bbcf.png";